import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateRangeModel } from '../../models/date-range-picker/date-range.model';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';
import { NgbDate, NgbCalendar, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangePickerComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [
    NgbDatepickerModule,
    FormsModule,
  ],
})
export class DateRangePickerComponent implements ControlValueAccessor, OnInit {

  startDate: NgbDate | null;
  endDate: NgbDate | null;
  hoveredDate: NgbDate | null = null;
  selectedDateRange: string;
  @Input() lotOrHipText: string;
  disabled = false;

  ngOnInit(): void {
    this.dateParserFormatter.setIsUSTimeZone(this.lotOrHipText);
  }
  constructor(private calendar: NgbCalendar,@Inject(DateParserFormatter) public dateParserFormatter: DateParserFormatter) {

  }
 
  // Implement ControlValueAccessor methods
  writeValue(value: DateRangeModel): void {
    // Update the component when the form control value changes
    this.startDate = value.startDate;
    this.endDate = value.endDate;
    this.setDateRangePickerValue();
  }

  registerOnChange(fn: any): void {
    // Register a callback function to be called when the form control value changes
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    // Register a callback function to be called when the component is touched (e.g., on blur)
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Set the component's disabled state based on the form control
    this.disabled = isDisabled;
  }

 
  onDateSelection(date: NgbDate) {
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (this.startDate && !this.endDate && date && date.after(this.startDate)) {
      this.endDate = date;
    } else {
      this.endDate = null;
      this.startDate = date;
    }
    this.setDateRangePickerValue();
  }

  isHovered(date: NgbDate) {
    return (
      this.startDate && !this.endDate && this.hoveredDate && date.after(this.startDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.dateParserFormatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
  public setDateRangePickerValue() {
    const startDate = this.dateParserFormatter.format(this.startDate);
    const endDate = this.dateParserFormatter.format(this.endDate);
    this.selectedDateRange = `${startDate} - ${endDate}`;
    this.updateValue();
  }
  private updateValue() {
    // Update the component's value and notify Angular forms
    const dateRange: DateRangeModel = new DateRangeModel();
    dateRange.startDate = this.startDate;
    dateRange.endDate = this.endDate;
    this.onChangeCallback(dateRange);
  }

  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };
}

